import { openDB } from "idb";
import { ProductItem } from "src/shared/services/interface";

export const dbPromise = openDB("POS_GROCERY", 2, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("products")) {
      const store = db.createObjectStore("products", { keyPath: "_id" });
      store.createIndex("barcode", "barcodeId");
    }
  },
});

/** Save Products */
export const saveProductsToIndexedDB = async (products: ProductItem[]) => {
  const db = await dbPromise;

  const tx = db.transaction("products", "readwrite");
  const store = tx.objectStore("products");

  for (const product of products) {
    let id: any = product?._id;
    // If Mongo format { $oid: "..." }
    if (typeof id === "object" && id?.$oid) {
      id = id.$oid;
    }

    // Convert to string
    if (id) {
      id = String(id);
    }

    // Skip invalid
    if (!id) {
      console.warn("Skipping invalid product:", product);
      continue;
    }

    const formattedProduct = {
      ...product,
      _id: id,
    };
    await store.put(formattedProduct);
  }

  await tx.done;
};

/** Get Products */
export const getProductsFromIndexedDB = async () => {
  const db = await dbPromise;
  return db.getAll("products");
};
